import React from 'react';
import { Link } from 'react-router-dom';

export default function TreatmentPage({
  pageContent,
  candidateImage,
  candidateAlt,
  cautionImage,
  cautionAlt,
  beforeImage,
  beforeAlt,
  afterImage,
  afterAlt,
  ctaTo,
  ctaLabel,
}) {
  return (
    <main className="page page--treatment">
      <section className="page-section page-section--intro">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{pageContent.tag}</span>
          <h1>{pageContent.title}</h1>
          <p>{pageContent.text}</p>
        </div>
      </section>

      <section className="page-section treatment-grid">
        <article className="content-card content-card--image-top">
          <img src={candidateImage} alt={candidateAlt} className="content-card__image" />
          <div className="content-card__body">
            <h2>{pageContent.candidateTitle}</h2>
            <div className="stack-grid">
              {pageContent.candidates.map((item) => (
                <div key={item.title} className="mini-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </article>

        <article className="content-card content-card--image-top">
          <img src={cautionImage} alt={cautionAlt} className="content-card__image" />
          <div className="content-card__body">
            <h2>{pageContent.cautionTitle}</h2>
            <ul className="bullet-list">
              {pageContent.cautions.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </article>
      </section>

      <section className="page-section split-grid">
        <article className="content-card content-card--side-image">
          <img src={beforeImage} alt={beforeAlt} className="content-card__image content-card__image--portrait" />
          <div className="content-card__body">
            <h2>{pageContent.beforeTitle}</h2>
            <div className="stack-grid">
              {pageContent.before.map((item) => (
                <div key={item.title} className="mini-card mini-card--soft">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </article>

        <article className="content-card content-card--side-image reverse-on-desktop">
          <img src={afterImage} alt={afterAlt} className="content-card__image content-card__image--portrait" />
          <div className="content-card__body">
            <h2>{pageContent.afterTitle}</h2>
            <div className="stack-grid">
              {pageContent.after.map((item) => (
                <div key={item.title} className="mini-card mini-card--soft">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </article>
      </section>

      <section className="page-section">
        <div className="cta-banner">
          <div>
            <span className="section-heading__eyebrow">{pageContent.tag}</span>
            <h2>{pageContent.title}</h2>
          </div>
          <Link to={ctaTo} className="button button--primary">
            {ctaLabel}
          </Link>
        </div>
      </section>
    </main>
  );
}
